<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="invoiceTypes"
    item-value="id"
    :item-text="render"
    clearable
    return-object
  >
    <template v-slot:selection="data">{{ render(data.item) }}</template>
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "InvoiceTypeField",
  props: {
    value: Object,
    showKey: { type: Boolean, default: false },
    status: { type: String, required: false, default: "Active" }
  },
  data: () => ({
    invoiceTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    render(item) {
      let response = item.name;
      if (this.showKey) {
        response = item.invoiceTypeKey + " - " + response;
      }
      if (item.currency) {
        response += " (" + item.currency.name + ")";
      }
      return response;
    }
  },
  mounted() {
    let filters = {};

    filters.isEffective = this.status;

    ApiService.post("/api/invoiceTypes/search?sort=name&size=100", filters).then(({ data }) => {
      this.invoiceTypes = data.content;
    });
  }
};
</script>
